/* eslint-disable no-new-func */
import copyToClipboard from './util/copyToClipboard';

export default class Alert {
  constructor(welContainer) {
    this.welContainer = welContainer;

    this.fCancelBtnCallback = new Function();
    this.fBtn1Callback = new Function();
    this.fBtn2Callback = new Function();
    // snsShare는 딜인포가 필수이기에 최초 리뷰등록완료시에 세팅하도록 한다.
    this.snsShareObj = null;

    this.init();
  }

  init() {
    this.renderAlert();
    this.cacheElement();
    this.setEvent();
  }

  /**
   * element caching
   */
  cacheElement() {
    this.welCloseButton = this.welAlert.querySelector('.btn_pop_close');
    this.welTitle = this.welAlert.querySelector('h4');
    this.welContents = this.welAlert.querySelector('.write_pop_contents');
    this.welButton1 = this.welAlert.querySelector('#_button1');
    this.welButton2 = this.welAlert.querySelector('#_button2');
    this.welShareArea = this.welAlert.querySelector('#_share_on_review');
  }

  /**
   * event 바인딩
   */
  setEvent() {
    // cancel callback
    this.welCloseButton.addEventListener('click', () => {
      this.fCancelBtnCallback();
    });
    // button1 callback
    this.welButton1.addEventListener('click', () => {
      this.fBtn1Callback();
    });
    // button2 callback
    this.welButton2.addEventListener('click', () => {
      this.fBtn2Callback();
    });
  }

  /**
   * [SDLUI-1434]
   * IOS 앱버젼 5.1.3 미만에서는 sms 공유 이슈가 있기 때문에 alert로 업데이트 요청
   */
  checkSmsShareAvailableInIos() {
    if (
      !TMON.bIsMobileWeb &&
      TMON.bIsIos &&
      !TMON.app[`${'_isValidAppVersion'}`]('5.1.3')
    ) {
      this.welShareArea.querySelector('.sms').addEventListener('click', () => {
        alert('티몬 앱 버전이 낮습니다. 업데이트를 실행해주세요');
      });
      return false;
    }
    return true;
  }

  /**
   * show/hide toggle
   * @param {boolean} bIsShow
   */
  toggle(bIsShow = true) {
    this.welAlert.style.display = bIsShow ? 'block' : 'none';
  }

  /**
   * alert option setting
   * @param {
   * sTitle: string (alert title)
   * sContents: string (alert contents)
   * oButton1: {
   *  bIsShow: boolean (button1 show/hide)
   *  sContents: string (button1 contents)
   *  color: 'white' | 'orange'
   * }
   * oButton2: {
   *  bIsShow: boolean (button1 show/hide)
   *  sContents: string (button1 contents)
   *  color: 'white' | 'orange'
   * }
   * bIsShowshareArea: boolean (shareArea show/hide)
   * } oOptions
   */
  setOptions(
    oOptions = {
      sTitle: '',
      sContents: '',
      oButton1: { bIsShow: false, sContents: '' },
      oButton2: { bIsShow: false, sContents: '' },
      bIsShowshareArea: false,
    }
  ) {
    this.welTitle.innerHTML = oOptions.sTitle;
    this.welContents.innerHTML = oOptions.sContents;

    this.welButton1.style.display = oOptions.oButton1.bIsShow
      ? 'block'
      : 'none';
    this.welButton1.innerHTML = oOptions.oButton1.sContents;
    if (oOptions.oButton1) {
      if (oOptions.oButton1.color === 'white') {
        this.welButton1.classList.add('white');
      } else {
        this.welButton1.classList.remove('white');
      }
    }

    this.welButton2.style.display = oOptions.oButton2.bIsShow
      ? 'block'
      : 'none';
    this.welButton2.innerHTML = oOptions.oButton2.sContents;
    if (oOptions.oButton2) {
      if (oOptions.oButton2.color === 'white') {
        this.welButton2.classList.add('white');
      } else {
        this.welButton2.classList.remove('white');
      }
    }

    this.welShareArea.style.display = oOptions.bIsShowshareArea
      ? 'block'
      : 'none';
    if (oOptions.bIsShowshareArea && !this.snsShareObj) {
      this.setSnsShare();
    }
  }

  setSnsShare() {
    const {
      htDealInfo: {
        priceInfo: { price },
        titleImage,
        subTitleImage,
        contentInfo: {
          contentImages: { frontImages },
        },
        isDelegatePriceOver,
      },
      sMainDealSrl,
    } = TMON.oModuleReview.oWrite;
    const htSnsShare = {
      sContent: price
        ? `${TMON.util.numberFormat(price)}원${isDelegatePriceOver ? '~' : ''}`
        : subTitleImage,
      sUrl: `${TMON.htCommonUrl.www_m_dealDetail}/${sMainDealSrl}`,
      sHashTags: '티몬',
      sSelector: `#_share_on_review button${
        this.checkSmsShareAvailableInIos() ? '' : ':not(.sms)'
      }`,
      sDealNo: sMainDealSrl,
      sImage: frontImages && frontImages[0] ? frontImages[0] : '',
      sTitle: titleImage ? `[티몬] ${titleImage}` : '',
      cbOnCompleted: arg => {
        if (TMON.view_mode !== 'app' && arg[0] === 'urlcopy') {
          if (copyToClipboard(htSnsShare.sUrl)) {
            alert(
              '클립보드에 복사되었습니다.\n공유하고 싶은 곳에 붙여넣기 하세요'
            );
          } else {
            alert(
              'URL 복사를 지원하지 않는 브라우저입니다. 상단 주소창의 URL 을 복사해 공유해 주세요!'
            );
          }
        }
      },
    };
    /**
     * SnsShare 객체는 앱에서 1개로 유지한다. */
    // eslint-disable-next-line new-cap, no-new
    this.snsShareObj = new SnsShare(htSnsShare);
  }

  /**
   * alert html render
   * 딜상세에서 사용시 공유버튼 TLlog 코드를 확인해주세요
   */
  renderAlert() {
    const sAlertHtml = `<div class="write_pop_wrap" id="_alertPop" style="display: none;">
                <article class="write_pop_article">
                    <div class="write_pop_header type2">
                        <h4></h4>
                        <button type="button" class="btn_pop_close"><span class="blind">닫기</span></button>
                    </div>
                    <div class="write_pop_contents"></div>
                    <div class="write_pop_footer">
                        <button type="button" id="_button1" class="btn_pop_button" style="display:none;"></button>
                        <button type="button" id="_button2" class="btn_pop_button" style="display:none;"></button>
                    </div>
                    <div id="_share_on_review" class="write_pop_share">
                        <h4>이 상품을 공유해보세요!</h4>
                        <ul class="icon_list">
                            <li class="icon_list_item">
                                <button type="button" class="icon_list_button kakao" aria-label="카카오톡으로 공유하기" data-type="kakaotalk" tl:area="RCDS" tl:ord=1></button>
                            </li>
                            <li class="icon_list_item">
                                <button type="button" class="icon_list_button facebook" aria-label="페이스북으로 공유하기" data-type="facebook" tl:area="RCDS" tl:ord=2></button>
                            </li>
                            <li class="icon_list_item">
                                <button type="button" class="icon_list_button sms" aria-label="문자로 공유하기" data-type="sms" tl:area="RCDS" tl:ord=3></button>
                            </li>
                            <li class="icon_list_item">
                                <button type="button" class="icon_list_button url" aria-label="URL로 공유하기" data-type="urlcopy"  tl:area="RCDS" tl:ord=4></button>
                            </li>
                        </ul>
                    </div>
                </article>
            </div>`;

    this.welContainer.append(sAlertHtml);
    this.welAlert = this.welContainer.find('#_alertPop').get(0);
  }
}
